export const appOrdersAccordion = {
    create: function(){
        var that = this;
        if($('.js-orders-acc').length){
            that.bindEvents();
        }
    },
    bindEvents: function(){
        var that = this;
        $(document).on('click', '.js-ooa-toggle', function(){
            var ooAcc = $(this).closest('.js-orders-acc'),
                ooaContent = $(ooAcc).find('.js-ooa-content'),
                accState = $(this).attr('aria-expanded') == 'false' ? 'closed' : 'open';
            if(accState == 'closed'){
                $(this).attr('aria-expanded', 'true');
                $(ooaContent).attr('aria-hidden', 'false');
            } else {
                $(this).attr('aria-expanded', 'false');
                $(ooaContent).attr('aria-hidden', 'true');
            }
        });
    }
};